import axios from 'axios'

const getFeelgreat = async ({ countryCode3Alpha, userStatus }: { countryCode3Alpha: string; userStatus: string }) => {
    const response = await axios.get(`https://member-calls2.unicity.com/products-v2/feelGreat/v3/publish/${countryCode3Alpha}?baStatus=${userStatus}`)
    return response
}

export type TValidateOrderLimit = {
    baId: string | number
    countryCode3Alpha: string
    period: string
    totalPrice: number
    totalPv: number
    subtotalPrice: number
    orderDataItems: TOrderDataItems[]
}
type TOrderDataItems = {
    item_code: string
    quantity: number | string
    price: number | string
    pv: number | string
}
const validateOrderLimit = async ({ baId, countryCode3Alpha, period, totalPrice, totalPv, subtotalPrice, orderDataItems }: TValidateOrderLimit) => {
    const data = {
        baId: baId,
        country_code: countryCode3Alpha,
        site: 'spotlight',
        period: period,
        total_price: totalPrice,
        total_pv: totalPv,
        subtotal_price: subtotalPrice,
        orderDataItems: orderDataItems
    }

    const response = await axios.post(`https://member-calls2.unicity.com/cart-limit/public/check?ordercalC=1`, data)
    return response
}

export const orderDetailsApis = {
    getFeelgreat,
    validateOrderLimit
}
